import React, { useState } from "react";
import PropTypes from "prop-types";
import ConsentRadioButton from "./ConsentRadioButton";
import { Button, ButtonGroup } from "../Form/Button";
import CBContext from "./CBContext";
var ConsentBannerManagement = function (props) {
    var managementTitle = props.managementTitle, ariaControl = props.ariaControl, description = props.description, children = props.children, acceptRadioLabel = props.acceptRadioLabel, refuseRadioLabel = props.refuseRadioLabel, closeButtonLabel = props.closeButtonLabel;
    var _a = useState(false), allAcceptChecked = _a[0], setAllAcceptChecked = _a[1];
    var _b = useState(false), allRefuseChecked = _b[0], setAllRefuseChecked = _b[1];
    var contextProps = {
        isAcceptAllChecked: allAcceptChecked,
        isRefuseAllChecked: allRefuseChecked,
    };
    var handleAcceptCallback = function (data) {
        setAllAcceptChecked(data);
        setAllRefuseChecked(!data);
    };
    var handleRefuseCallback = function (data) {
        setAllRefuseChecked(data);
        setAllAcceptChecked(!data);
    };
    return (React.createElement(CBContext.Provider, { value: contextProps },
        React.createElement("dialog", { id: ariaControl, className: "fr-modal", role: "dialog", "aria-labelledby": "fr-consent-modal-title" },
            React.createElement("div", { className: "fr-container fr-container--fluid fr-container-md" },
                React.createElement("div", { className: "fr-grid-row fr-grid-row--center" },
                    React.createElement("div", { className: "fr-col-12 fr-col-md-10 fr-col-lg-8" },
                        React.createElement("div", { className: "fr-modal__body" },
                            React.createElement("div", { className: "fr-modal__header" },
                                React.createElement("button", { className: "fr-btn--close fr-btn", "aria-controls": ariaControl }, closeButtonLabel)),
                            React.createElement("div", { className: "fr-modal__content" },
                                React.createElement("h1", { id: "fr-consent-modal-title", className: "fr-modal__title" }, managementTitle),
                                React.createElement("div", { className: "fr-consent-manager" },
                                    React.createElement("div", { className: "fr-consent-service fr-consent-manager__header" },
                                        React.createElement("fieldset", { className: "fr-fieldset fr-fieldset--inline" },
                                            React.createElement("legend", { id: "finality-legend", className: "fr-consent-service__title" },
                                                description,
                                                React.createElement(ConsentRadioButton, { radioName: "management", acceptRadioLabel: acceptRadioLabel, refuseRadioLabel: refuseRadioLabel, onAcceptCallback: handleAcceptCallback, onRefuseCallback: handleRefuseCallback })))),
                                    children,
                                    React.createElement(ButtonGroup, { className: "fr-consent-banner__buttons", align: "right", isInlineFrom: "sm" },
                                        React.createElement(Button, { "aria-controls": ariaControl }, "Confirmer mes choix")))))))))));
};
ConsentBannerManagement.defaultProps = { __TYPE: "ConsentBannerManagement" };
ConsentBannerManagement.propTypes = { __TYPE: PropTypes.any };
export default ConsentBannerManagement;
